document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-creators-form]').forEach((root) => {
    const form = root.querySelector('form');
    const note = root.querySelector('[data-creator-note]');
    if (!form || !note) return;

    form.addEventListener('submit', (event) => {
      const socialLinks = [...root.querySelectorAll('[data-note-field="Instagram"], [data-note-field="TikTok"], [data-note-field="YouTube / Other"]')]
        .some((field) => field.value.trim());
      if (!socialLinks) {
        event.preventDefault();
        const first = root.querySelector('[data-note-field="Instagram"]');
        first.setCustomValidity(document.documentElement.lang.startsWith('fr') ? 'Ajoutez au moins un lien vers un réseau social.' : 'Add at least one social profile link.');
        first.reportValidity();
        return;
      }

      note.value = [...root.querySelectorAll('[data-note-field]')]
        .filter((field) => field.value.trim())
        .map((field) => `${field.dataset.noteField}: ${field.value.trim()}`)
        .join('\n');
    });

    root.querySelectorAll('[data-note-field="Instagram"], [data-note-field="TikTok"], [data-note-field="YouTube / Other"]').forEach((field) => {
      field.addEventListener('input', () => field.setCustomValidity(''));
    });
  });
});
